const Months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'Setptember',
    'October',
    'November',
    'December',
];

export default Months;



// WEBPACK FOOTER //
// ./src/utils/Months/index.js